"use client";

import { Flex, type ButtonProps } from "@chakra-ui/react";
import { HiOutlineAdjustmentsHorizontal } from "react-icons/hi2";
import { Button } from "./Button";
import { Text } from "./Text";
import { useThemeTokens } from "@/lib/theme/tokens";

export interface FiltersTriggerButtonProps {
  onClick: () => void;
  activeCount?: number;
  hasUnapplied?: boolean;
  w?: ButtonProps["w"];
  flexShrink?: ButtonProps["flexShrink"];
  "data-testid"?: string;
}

export function FiltersTriggerButton({
  onClick,
  activeCount = 0,
  hasUnapplied = false,
  w = { base: "100%", md: "auto" },
  flexShrink,
  "data-testid": dataTestId,
}: FiltersTriggerButtonProps) {
  const theme = useThemeTokens();
  const showBadge = activeCount > 0 || hasUnapplied;

  return (
    <Button
      variant="outline"
      h="44px"
      w={w}
      flexShrink={flexShrink}
      onClick={onClick}
      data-testid={dataTestId}
      position="relative"
      borderColor={
        hasUnapplied ? theme.accent.primary : theme.borderGlass.default
      }
      color={hasUnapplied ? theme.accent.primary : theme.text.primary}
      bg={hasUnapplied ? theme.accent.primaryBg : "transparent"}
      _hover={{
        borderColor: theme.accent.primary,
        bg: theme.accent.primaryBg,
      }}
    >
      <Flex align="center" gap={2}>
        <HiOutlineAdjustmentsHorizontal size={18} />
        <Text fontSize="sm" fontWeight="500">
          Filters
        </Text>
        {showBadge && (
          <Flex
            as="span"
            align="center"
            justify="center"
            minW="20px"
            h="20px"
            px={1.5}
            borderRadius="full"
            fontSize="xs"
            fontWeight="700"
            bg={theme.accent.primary}
            color="white"
            lineHeight="1"
          >
            {activeCount > 0 ? activeCount : "•"}
          </Flex>
        )}
      </Flex>
    </Button>
  );
}
